import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FlowControlSlidingWindow = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Flow Control Mechanism – Sliding Window Protocol: Go-Back-N & Selective Repeat"
    videos={[
      "https://www.youtube.com/embed/LnbvhoxHn8M",
      "https://www.youtube.com/embed/QD3oCelHJ20",
      "https://www.youtube.com/embed/WfIhQ3o2xow"
    ]}
    takeaways={[
      { text: "Try to do previous year questions; almost similar models come for CAT2." }
    ]}
    questions={[
      "Consider a scenario where Station A needs to transmit a message containing 10 frames to Station B using sliding window protocol. Set the sender's window size as 3. Assume, every 5th transmission is lost, while acknowledgments from the receiver for other transmissions are never lost. After every 5th transmission loss, the remaining frames within the window are sent to the receiver. Subsequently a timeout occurs. Draw the timing diagram and determine the total number of data transmissions made by the sender (including retransmissions) if it follows: i. Go-Back-N protocol ii. Selective Repeat Protocol. Also, calculate the ratio of the effective number of frames sent to the total number of frames sent in each of the above cases.",
      "Consider sliding window with m=2 and demonstrate how Go-Back N protocol will work for the below scenario with a neat time-sequence diagram: Except first packet, all other packets in transmitter window reached the receiver; Acknowledgement for zeroth packet got lost. All other packets and acknowledgements transmitted successfully. Assume there is no loss of packets or acknowledgements during retransmission.",
      "A software developer was given a task to write a code to send 8 frames (assuming every 4th frame is getting lost). He has the option to choose either of the three algorithms, Stop & Wait, Go-Back-3 or Selective Repeat. Justify your answer with the timing diagram.",
      "Draw the sender and receiver windows for a system using Selective Repeat ARQ (3-bits for sequence number), given the following: i) Frame 0 is sent; frame 0 is acknowledged. ii) Frames 1 and 2 are sent; frames 1 and 2 are acknowledged. iii) Frames 3, 4, and 5 are sent; frame 4 is acknowledged; the timer for frame 5 expires. iv) Frames 5, 6, and 7 are sent; frames 4 through 7 are acknowledged."
    ]}
    exampleVideos={[]}
  />
);
}

export default FlowControlSlidingWindow;
